import React, { useEffect, useState, useRef, useMemo } from 'react'
import axios from 'axios'
import '../../../styles/FormEvenement.css'
import MenuAdmin from './MenuAdmin'
import JoditEditor from 'jodit-react'

const FormEvenement = ({ placeholder }) => {
  const editor = useRef(null)
  const [formData, setFormData] = useState({})
  const [textEvenement1, setTextEvenement1] = useState('')
  const [textEvenement2, setTextEvenement2] = useState('')
  const [selectedImage, setSelectedImage] = useState(null)
  const [imagePath, setImagePath] = useState('')

  useEffect(() => {
    lireJsonFile()
  }, [])

  useEffect(() => {
    setTextEvenement1(formData.textEvenement1 || '')
    setTextEvenement2(formData.textEvenement2 || '')
    setImagePath(formData.imagesrc || '')
  }, [formData])

  const handleTextEvenement1Change = (value) => {
    setTextEvenement1(value)
  }

  const handleTextEvenement2Change = (value) => {
    setTextEvenement2(value)
  }

  const handleFileSelect = (e) => {
    const file = e.target.files[0]
    // console.log('Fichier sélectionné :', file)
    if (!file) {
      console.error('Aucun fichier sélectionné.')
      return
    }
    if (!file.type.match('image.*')) {
      alert('Veuillez sélectionner une image valide.')
      return
    }
    setSelectedImage(file)
  }

  const handleImageUpload = async (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (!selectedImage) {
      alert("Veuillez d'abord choisir une image.")
      return
    }

    if (!(selectedImage instanceof File)) {
      alert("Le fichier sélectionné n'est pas valide.")
      return
    }

    const formDataImage = new FormData()
    formDataImage.append('file', selectedImage)
    // console.log(formDataImage)

    try {
      // console.log('Envoi de la requête...')
      const response = await axios.post(
        // Appel vers le serveur PHP local (Développement)
        // 'http://localhost:8000/uploadImage.php',
        // Appel vers le serveur (Production)
        './php/uploadImage.php',
        formDataImage
        // { timeout: 30000 }
      )

      // console.log('Réponse du serveur :', response.data)
      if (response.data.success) {
        const chemin = `./images/${response.data.filename}`
        setImagePath(chemin)
        alert('Image uploadée avec succès !')
      } else {
        alert('Erreur : ' + (response.data.message || 'Erreur inconnue'))
      }
    } catch (error) {
      console.error('Erreur complète :', error)
      alert("Erreur lors de l'upload. Voir la console pour plus de détails.")
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const formDonnees = new FormData(e.target)
    const lienEvenement = formDonnees.get('lienevenement')

    const objetJSON = {
      textEvenement1,
      textEvenement2,
      imagesrc: imagePath,
      imagedatasrc: imagePath,
      imagealt: 'Evenements Duo Danse',
      imagewidth: '200',
      imageheight: '400',
      imageclass: '',
      lien: lienEvenement,
    }
    saveJsonFile(JSON.stringify(objetJSON))
  }

  const lireJsonFile = () => {
    axios
      .get('./json/evenements.json')
      .then((response) => {
        setFormData(response.data)
      })
      .catch((error) => {
        console.error('Erreur lors de la mise à jour des données JSON', error)
      })
  }

  const saveJsonFile = async (donneesAEnregistrer) => {
    const nomFichier = 'evenements.json'
    const cheminFichier = '../json'
    if (donneesAEnregistrer) {
      try {
        const response = await axios.post(
          // Appel vers le serveur PHP local (Développement)
          // 'http://localhost:8000/enregistrejson_v2.php',
          // Appel vers le serveur (Production)
          './php/enregistrejson_v2.php',
          {
            nomFichier,
            cheminFichier,
            donneesJson: donneesAEnregistrer,
          }
        )
        if (response.status === 200) {
          alert("L'article a bien été enregistré.")
        } else {
          alert("L'article n'a pas été enregistré.")
        }
      } catch (error) {
        console.error("Erreur lors de l'enregistrement du fichier:", error)
      }
    }
  }

  const buttons = [
    'undo',
    'redo',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    '|',
    'superscript',
    'subscript',
    '|',
    'align',
    '|',
    'ul',
    'ol',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'link',
    '|',
    'hr',
    'selectall',
    '|',
    'source',
  ]

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || '',
      toolbar: true,
      spellcheck: true,
      language: 'fr',
      toolbarButtonSize: 'medium',
      toolbarAdaptive: false,
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: true,
      askBeforePasteFromWord: true,
      buttons: buttons,
    }),
    [placeholder]
  )

  return (
    <div id="formEvenement" className="formEvenement">
      <MenuAdmin />
      <div className="enveloppe">
        <form onSubmit={handleSubmit}>
          <h2>EVENEMENTS</h2>

          <h1>Texte 1</h1>
          <JoditEditor
            ref={editor}
            value={textEvenement1}
            config={config}
            tabIndex={1}
            onChange={handleTextEvenement1Change}
          />

          <h1>Texte 2</h1>
          <JoditEditor
            ref={editor}
            value={textEvenement2}
            config={config}
            tabIndex={2}
            onChange={handleTextEvenement2Change}
          />

          <div id="containerChoixImage" className="containerChoixImage">
            <div className="uploadSection">
              <div className="label">
                Si l'image n'est pas sur le serveur, choisissez une image
                "Parcourir..." et Uploader l'image.
              </div>
              <input type="file" accept="image/*" onChange={handleFileSelect} />
              <button type="button" onClick={handleImageUpload}>
                Uploader l'image
              </button>
            </div>
            <div className="inputChoixImage">
              <div className="label">
                Si l'image est déjà sur le serveur, entrez son nom avec son
                extension ci-dessous.
              </div>
              <span className="chImage" htmlFor="inputimage">
                Chemin image :{' '}
              </span>
              <input
                name="inputimage"
                type="text"
                id="inputimage"
                value={imagePath}
                onChange={(e) => setImagePath(e.target.value)}
                required
              />
            </div>
          </div>

          <span className="label" htmlFor="lienevenement">
            Lien
          </span>
          <input
            name="lienevenement"
            type="text"
            id="lienevenement"
            defaultValue={formData.lien}
            required
          />
          <div>
            <button
              type="submit"
              id="btenregistrerEvenement"
              className="btenregistrerEvenement"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </div>

      <div id="visuEvenement" className="visuEvenement">
        <div id="section-Evenements" className="sectionEvenements">
          <div id="texte-Evenements" className="containerTexteEvenements">
            <div id="text-Evenements-1" className="blockText">
              <p dangerouslySetInnerHTML={{ __html: textEvenement1 }} />
            </div>
            <div id="textEvenements2" className="blockText">
              <blockquote>
                <p dangerouslySetInnerHTML={{ __html: textEvenement2 }} />
              </blockquote>
            </div>
          </div>

          <div id="image" className="containerImageEvenements">
            <figure id="img_bloc" className="blocImageEvenements">
              <img
                src={imagePath || formData.imagesrc}
                alt="Evenements Duo Danse"
                width="200"
                height="400"
              />
            </figure>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormEvenement
